(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mm-oferta"] && !Shopify.designMode) return;
  try {
    (function () {
  function fmtMoney(cents) {
    var n = (Number(cents) || 0) / 100;
    try {
      return '$' + n.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function pintarBarra(root, transfer) {
    if (root.getAttribute('data-sticky') !== 'true') return;
    var caja = document.querySelector('.sticky-add-to-cart__price');
    if (!caja) return;
    var el = caja.querySelector('.mm-sticky-tr');
    if (!el) {
      el = document.createElement('span');
      el.className = 'mm-sticky-tr';
      caja.appendChild(el);
    }
    var texto = root.getAttribute('data-sticky-texto') || 'por transferencia';
    el.textContent = fmtMoney(transfer) + ' ' + texto;
  }

  function initRoot(root) {
    if (root.dataset.mmBound === '1') return;
    root.dataset.mmBound = '1';

    var dataEl = root.querySelector('.mm-oferta-data');
    if (!dataEl) return;
    var map;
    try { map = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var factor = parseInt(root.getAttribute('data-factor'), 10);
    if (isNaN(factor)) factor = 90;
    var showList = root.getAttribute('data-lista') === 'true';

    var section = root.closest('.shopify-section') || document;

    function getVid() {
      var el = section.querySelector('input[name="id"], select[name="id"]');
      return el ? String(el.value) : null;
    }

    function selectedValues() {
      var groups = [];
      var seen = {};
      var radios = section.querySelectorAll('variant-picker input[type="radio"]:checked, .variant-option input[type="radio"]:checked, fieldset input[type="radio"]:checked');
      for (var i = 0; i < radios.length; i++) {
        var nm = radios[i].name;
        if (!seen[nm]) { seen[nm] = 1; groups.push(radios[i].value); }
      }
      return groups;
    }

    function resolveVid() {
      var vals = selectedValues();
      if (!vals.length) return null;
      for (var vid in map) {
        var o = map[vid] && map[vid].o;
        if (o && o.length === vals.length) {
          var ok = true;
          for (var i = 0; i < vals.length; i++) {
            if (String(o[i]) !== String(vals[i])) { ok = false; break; }
          }
          if (ok) return vid;
        }
      }
      return null;
    }

    function update() {
      var vid = resolveVid() || getVid();
      if (!vid || map[vid] == null) return;
      var p = Number(map[vid].p);
      var transfer = Math.floor(p * factor / 100);

      var nowEl = root.querySelector('[data-role="now"]');
      if (nowEl) nowEl.textContent = fmtMoney(transfer);

      var wasEl = root.querySelector('[data-role="was"]');
      if (wasEl) {
        wasEl.textContent = fmtMoney(p);
        if (showList && p > transfer) { wasEl.removeAttribute('hidden'); }
        else { wasEl.setAttribute('hidden', ''); }
      }

      pintarBarra(root, transfer);
    }

    section.addEventListener('change', function () {
      window.requestAnimationFrame(update);
    });

    var idInput = section.querySelector('input[name="id"]');
    if (idInput && 'MutationObserver' in window) {
      new MutationObserver(update).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    // La barra fija se dibuja aparte y puede refrescar su precio: si eso borra nuestra linea,
    // la volvemos a escribir.
    var barra = document.querySelector('.sticky-add-to-cart__price');
    if (barra && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (!barra.querySelector('.mm-sticky-tr')) update();
      }).observe(barra, { childList: true, subtree: true });
    }

    update();
  }

  function boot() {
    document.querySelectorAll('.mm-oferta').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mm-stock"] && !Shopify.designMode) return;
  try {
    (function () {
  function fmtMoney(cents) {
    var n = (Number(cents) || 0) / 100;
    try {
      return '$' + n.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function stockState(data, low) {
    if (data.tracked) {
      var q = Number(data.qty) || 0;
      if (q > low) return { state: 'in', label: q === 1 ? '1 disponible' : q + ' disponibles' };
      if (q > 0) return { state: 'low', label: q === 1 ? '¡Última unidad disponible!' : '¡Últimas ' + q + ' unidades!' };
      return { state: 'out', label: 'A pedido' };
    }
    return data.available ? { state: 'in', label: 'Disponible' } : { state: 'out', label: 'A pedido' };
  }

  function initRoot(root) {
    if (root.dataset.mmBound === '1') return;
    root.dataset.mmBound = '1';

    var dataEl = root.querySelector('.mm-stock-data');
    if (!dataEl) return;
    var map;
    try { map = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var low = parseInt(root.getAttribute('data-low'), 10) || 3;
    var divisor = parseFloat(root.getAttribute('data-divisor')) || 1.21;

    var section = root.closest('.shopify-section') || document;

    function getVid() {
      var el = section.querySelector('input[name="id"], select[name="id"]');
      return el ? String(el.value) : null;
    }

    function selectedValues() {
      var groups = [];
      var seen = {};
      var radios = section.querySelectorAll('variant-picker input[type="radio"]:checked, .variant-option input[type="radio"]:checked, fieldset input[type="radio"]:checked');
      for (var i = 0; i < radios.length; i++) {
        var nm = radios[i].name;
        if (!seen[nm]) { seen[nm] = 1; groups.push(radios[i].value); }
      }
      return groups;
    }

    function resolveVid() {
      var vals = selectedValues();
      if (!vals.length) return null;
      for (var vid in map) {
        var o = map[vid] && map[vid].o;
        if (o && o.length === vals.length) {
          var ok = true;
          for (var i = 0; i < vals.length; i++) {
            if (String(o[i]) !== String(vals[i])) { ok = false; break; }
          }
          if (ok) return vid;
        }
      }
      return null;
    }

    function update() {
      var vid = resolveVid() || getVid();
      if (!vid || !map[vid]) return;
      var data = map[vid];

      var skuEl = root.querySelector('[data-role="sku"]');
      var skuWrap = root.querySelector('[data-role="skuwrap"]');
      var copyBtn = root.querySelector('[data-role="skucopy"]');
      if (skuEl) {
        skuEl.textContent = data.sku || '';
        if (skuWrap) { if (data.sku) { skuWrap.removeAttribute('hidden'); } else { skuWrap.setAttribute('hidden', ''); } }
        if (copyBtn) { copyBtn.setAttribute('data-mm-copy', data.sku || ''); }
      }

      var netoEl = root.querySelector('[data-role="neto"]');
      if (netoEl && data.price != null) {
        netoEl.textContent = fmtMoney(Math.round(Number(data.price) / divisor));
      }

      var box = root.querySelector('[data-role="stockbox"]');
      var lbl = root.querySelector('[data-role="stocklabel"]');
      var st = stockState(data, low);
      if (box) { box.classList.remove('mm-stock--in', 'mm-stock--low', 'mm-stock--out'); box.classList.add('mm-stock--' + st.state); }
      if (lbl) { lbl.textContent = st.label; }
    }

    section.addEventListener('change', function () {
      window.requestAnimationFrame(update);
    });

    var idInput = section.querySelector('input[name="id"]');
    if (idInput && 'MutationObserver' in window) {
      new MutationObserver(update).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    update();
  }

  function boot() {
    document.querySelectorAll('.mm-stockroot').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (!window.__mmSkuCopyBound) {
    window.__mmSkuCopyBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.mm-sku__copy');
      if (!btn) return;
      var val = btn.getAttribute('data-mm-copy') || '';
      var flash = function () {
        btn.classList.add('is-copied');
        window.setTimeout(function () { btn.classList.remove('is-copied'); }, 1500);
      };
      var fallback = function (text) {
        var ta = document.createElement('textarea');
        ta.value = text; ta.setAttribute('readonly', '');
        ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (err) {}
        document.body.removeChild(ta);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(val).then(flash).catch(function () { fallback(val); flash(); });
      } else { fallback(val); flash(); }
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mm-variant-imagen"] && !Shopify.designMode) return;
  try {
    (function () {
  function initRoot(root) {
    if (root.dataset.mmBound === '1') return;
    root.dataset.mmBound = '1';

    var mapEl = root.querySelector('.mm-vi-data');
    if (!mapEl) return;
    var map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }

    var section = root.closest('.shopify-section') || document;

    function radioByValue(val) {
      var radios = section.querySelectorAll('variant-picker input[type="radio"], .variant-option input[type="radio"], fieldset input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === val) return radios[i];
      }
      return null;
    }

    var currentEl = root.querySelector('[data-role="mm-vi-current"]');

    function markSelected(vid) {
      var opts = root.querySelectorAll('.mm-vi__opt');
      for (var i = 0; i < opts.length; i++) {
        var on = opts[i].getAttribute('data-variant-id') === String(vid);
        opts[i].classList.toggle('is-selected', on);
        opts[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      if (currentEl && map[vid] != null) {
        currentEl.textContent = map[vid];
      }
    }

    function currentVid() {
      var el = section.querySelector('input[name="id"]');
      return el ? String(el.value) : null;
    }

    function resync() {
      var vid = currentVid();
      if (vid) markSelected(vid);
    }

    function selectVariant(vid) {
      var opt = map[vid];
      if (opt == null) return;
      var radio = radioByValue(String(opt));
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      markSelected(vid);
      window.setTimeout(resync, 90);
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('.mm-vi__opt');
      if (!opt) return;
      e.preventDefault();
      var vid = opt.getAttribute('data-variant-id');
      if (vid) selectVariant(vid);
    });

    // Sincronizar el resaltado con el input[name="id"] ya asentado por Horizon.
    // Doble pasada (rAF + timeout) para ganar cualquier carrera de eventos en cascada.
    section.addEventListener('change', function () {
      window.requestAnimationFrame(resync);
      window.setTimeout(resync, 90);
    });

    // Respaldo autoritativo: si Horizon actualiza el atributo value del input.
    var idInput = section.querySelector('input[name="id"]');
    if (idInput && 'MutationObserver' in window) {
      new MutationObserver(resync).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    resync();
  }

  function boot() {
    document.querySelectorAll('.mm-variant-imagen').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
